export default "__VITE_ASSET__DoupwLrU__"